<template>
  <SegmentGroupAnswers
    :options="options"
    skipConfirmRemove
    noMargin
    noFilter
    buttonLabel="Add option"
    :key-field="'index'">
    <template #input="{ option, index }">
      <div class="flex w-full items-center gap-3">
        <InputText
          :modelValue="option.name"
          @update:modelValue="(value) => $emit('update:option', { ...option, name: value }, index)"
          class="w-full" />
        &rarr;
        <InputText
          :modelValue="option.id"
          @update:modelValue="(value) => $emit('update:option', { ...option, id: value }, index)"
          class="w-24" />
      </div>
    </template>
  </SegmentGroupAnswers>
</template>

<script setup lang="ts">
import SegmentGroupAnswers from '@dashboard/modules/segment/components/SegmentGroupAnswers.vue'
import InputText from 'primevue/inputtext'

defineProps<{
  options: { name: string; id: string }[]
}>()

defineEmits<{
  'update:option': [option: { name: string | null | undefined; id: string | null | undefined }, index: number]
}>()
</script>
